import { render, staticRenderFns } from "./SalesQuote.vue?vue&type=template&id=6b4145e5&"
import script from "./SalesQuote.vue?vue&type=script&lang=js&"
export * from "./SalesQuote.vue?vue&type=script&lang=js&"
import style0 from "./SalesQuote.vue?vue&type=style&index=0&id=6b4145e5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports